// import Modal from 'react-modal'; // Assuming you use react-modal
// import './App.css'; 

// // --- FilterModal Component ---
// const FilterModal = ({
//     isOpen,
//     onClose,
//     allColumns,
//     currentFilters,
//     onFilterChange,
//     onApplyFilters,
//     onClearSpecificFilter,
//     onClearAllFilters,
// }) => {
//     const filterableColumns = allColumns.filter(col => !col.startsWith('kn_') && col !== 'id' && col !== 'directory');

//     const modalStyle = {
//         content: { top: '50%', left: '50%', right: 'auto', bottom: 'auto', marginRight: '-50%', transform: 'translate(-50%, -50%)', width: '90%', maxWidth: '600px', maxHeight: '80vh', overflow: 'hidden', padding: '0', border: '1px solid #ccc', borderRadius: '8px', backgroundColor: '#fff', display: 'flex', flexDirection: 'column' },
//         overlay: { backgroundColor: 'rgba(0, 0, 0, 0.6)', zIndex: 1002 }, // Higher zIndex if needed
//     };
//     const headerStyle = { padding: '15px 20px', borderBottom: '1px solid #eee', fontWeight: 'bold', fontSize: '1.1em', backgroundColor: '#f8f9fa', flexShrink: 0 };
//     const contentStyle = { padding: '20px', overflowY: 'auto', flexGrow: 1 };
//     const footerStyle = { padding: '15px 20px', borderTop: '1px solid #eee', textAlign: 'right', backgroundColor: '#f8f9fa', flexShrink: 0 };
//     const filterItemStyle = { display: 'flex', alignItems: 'center', marginBottom: '10px', gap: '10px' };
//     const labelStyle = { flexBasis: '150px', textAlign: 'right', marginRight: '10px', fontSize: '0.9em' };
//     const inputStyle = { flexGrow: 1, padding: '8px', borderRadius: '4px', border: '1px solid #ccc' };
//     const smallButtonStyle = { padding: '3px 6px', fontSize: '0.8em', lineHeight: '1', marginLeft: '5px' };

//     if (!isOpen) return null;
//     return (
//         <Modal isOpen={isOpen} onRequestClose={onClose} style={modalStyle} contentLabel="Set Column Filters">
//             <div style={headerStyle}>Filter Data</div>
//             <div style={contentStyle}>
//                 {filterableColumns.length > 0 ? filterableColumns.map(col => (
//                     <div key={col} style={filterItemStyle}>
//                         <label htmlFor={`filter-${col}`} style={labelStyle}>{col}:</label>
//                         <input
//                             type="text"
//                             id={`filter-${col}`}
//                             style={inputStyle}
//                             value={currentFilters[col] || ''}
//                             onChange={(e) => onFilterChange(col, e.target.value)}
//                             placeholder={`Filter by ${col}...`}
//                         />
//                         {currentFilters[col] && (
//                             <button onClick={() => onFilterChange(col, '')} style={smallButtonStyle} title="Clear this filter">X</button>
//                         )}
//                     </div>
//                 )) : <p>No filterable columns available.</p>}
//             </div>
//             <div style={footerStyle} className="modal-button-group">
//                 <button onClick={onClearAllFilters} className="secondary">Clear All Filters</button>
//                 <button onClick={onApplyFilters} className="primary">Apply Filters & Search</button>
//                 <button onClick={onClose}>Cancel</button>
//             </div>
//         </Modal>
//     );
// };

// export default FilterModal;


// frontend/src/FilterModal.js
import Modal from 'react-modal';

const FilterModal = ({
    isOpen,
    onClose,
    allColumns,
    currentFilters,
    onFilterChange,
    onApplyFilters,
    onClearAllFilters,
}) => {
    // These columns are filterable in the modal.
    const filterableColumns = allColumns.filter(col => !col.startsWith('kn_') && col !== 'id' && col !== 'directory');

    if (!isOpen) return null;
    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            className="dataview-modal-content filter-modal"
            overlayClassName="modal-overlay"
            contentLabel="Set Column Filters"
            ariaHideApp={false}
        >
            <div className="modal-header">Filter Data</div>
            <div className="modal-content">
                {filterableColumns.length > 0 ? filterableColumns.map(col => (
                    <div key={col} className="filter-item">
                        <label htmlFor={`filter-${col}`} className="filter-label">{col}:</label>
                        <input
                            type="text"
                            id={`filter-${col}`}
                            className="filter-input"
                            value={currentFilters[col] || ''}
                            onChange={(e) => onFilterChange(col, e.target.value)}
                            placeholder={`Filter by ${col}...`}
                        />
                        {currentFilters[col] && (
                            <button
                                onClick={() => onFilterChange(col, '')}
                                className="filter-clear-button"
                                title="Clear this filter"
                            >
                                X
                            </button>
                        )}
                    </div>
                )) : <p>No filterable columns available.</p>}
            </div>
            <div className="modal-footer modal-button-group">
                <button onClick={onClearAllFilters} className="modal-cancel-button">Clear All & Close</button>
                <button onClick={onApplyFilters} className="modal-save-button">Apply Filters</button>
                <button onClick={onClose} className="modal-close-button">Cancel</button>
            </div>
        </Modal>
    );
};

export default FilterModal;